var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(!_vm.no ? '没有设备号，请联系管理员' :'')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }